import React, { useState, useEffect, useRef } from 'react'
import { GetDetail, PostInside, Update } from '../../web_api/api'
import { useLocation } from 'react-router-dom'
import { FaImages } from "react-icons/fa";
import { FiChevronRight } from 'react-icons/fi';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { Link } from 'react-router-dom';
import '../../branch/branch.css';
export default function TreatmentCreate() {
    //to get main id
    const location = useLocation()
    const ID = location.pathname.split('/')[2]

    //fields name
    const [name, setName] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [type, setType] = useState('')
    const [descriptionList, setDescriptionList] = useState([])
    const [image, setImage] = useState([])
    const [addSection, setAddSection] = useState([])
    const [showNextSection, setShowNextSection] = useState(false)
    const [showNextImage, setShowNextImage] = useState(false)

    const handleInputChange = (event, index, field) => {
        const newData = addSection.map((data, i) => {
            if (i === index) {
                return { ...data, [field]: event.target.value }
            }
            return data
        })
        setAddSection(newData)
    }



    const AddSection = () => {
        setAddSection([
            ...addSection,
            {
                title: title,
                description: description
            }
        ])
        setShowNextSection(true)
    }

    const localUrlsRef = useRef(new Set())

    const ImageAddSection = (e, index) => {
        const file = e.target.files[0]
        if (!file) return
        const url = URL.createObjectURL(file)
        localUrlsRef.current.add(url)
        setAddSection(prev => prev.map((s, i) =>
            i === index ? { ...s, localPreview: url, newFile: file } : s
        ))
    }

    useEffect(() => {
        return () => localUrlsRef.current.forEach(URL.revokeObjectURL)
    }, [])

    const create = async () => {
        const formData = new FormData()
        formData.append('name', name)
        formData.append('type', type)
        await Update('/blog/', ID, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    const handleOneUpdate = async (item) => {
        const formData = new FormData()
        if (item.newFile) {
            formData.append('blog', item.newFile)
        }
        formData.append('description', item.description)
        formData.append('title', item.title)
        await Update('/blog-update/', item._id, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    const handleOneAdd = async (item) => {
        const formData = new FormData()
        if (item.newFile) {
            formData.append('blog', item.newFile)
        }
        formData.append('description', item.description)
        formData.append('title', item.title)
        await PostInside('/blog/', ID, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    }


    useEffect(() => {
        const getData = async () => {
            const res = await GetDetail('blog/', ID)
            setName(res.data.name)
            setType(res.data.type)
            setDescriptionList(res.data.relatedDescription)
            setAddSection(res.data.relatedDescription)
            setImage(res.data.relatedDescription.map((i) => (i.imageUrl)))

        }

        getData()
    }, [])

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <Link to='/treatment-dashboard'>Treatments</Link>
                <FiChevronRight className='separator' size={14} />
                <span className='current'>Update Treatment</span>
            </div>

            <div className='branch-page-title'>Update Treatment</div>
            <div className='branch-page-subtitle'>Edit treatment details</div>

            <div className='branch-card'>
                <div className='branch-card-body'>
                    <div className='branch-form-grid'>
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Basic Information</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' for='#tn'>Treatment Name</label>
                                    <input type='text' id='tn' placeholder='Teatment Name' className='branch-input' value={name} onChange={(e) => setName(e.target.value)} />
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' for='#tn'>Treatment Type</label>
                                    <select className='branch-select' onChange={(e) => setType(e.target.value)}>
                                        <option hidden>{(type === 'face' ? 'Face & Skin' : (type === 'body' ? 'Body Contouring' : type === 'dental' ? 'Dental Care' : 'Choose Type ...'))}</option>
                                        <option value='face'>Face & Skin</option>
                                        <option value='body'>Body Contouring </option>
                                        <option value='dental'>Dental Care</option>
                                    </select>
                                </div>
                            </div>

                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Treatment Details</div>
                                {descriptionList ? (
                                    <>
                                        {addSection.map((item, index) => (
                                            <div className='branch-card' style={{ marginBottom: '16px', padding: '16px' }}>
                                                <h3 className='text-decoration-underline'>Tretment Detail Section {index + 1}</h3>
                                                <div className='branch-field'>
                                                    <label className='branch-field-label' for='#tn'>Title </label>
                                                    <input type='text' id='tn' placeholder='Title' className='branch-input' value={item.title} onChange={(e) => handleInputChange(e, index, 'title')} />
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className='col-12'>
                                                        <label className='branch-field-label' for='#tn'>Image </label>
                                                        <input type='file' id='tn' className='branch-input' onChange={(e) => ImageAddSection(e, index)} />
                                                        
                                                        {(item.localPreview || item.imageUrl) && (
                                                            <div className='mt-3 mb-2'>
                                                                <img 
                                                                    src={item.localPreview || item.imageUrl} 
                                                                    alt='preview' 
                                                                    style={{ width: '100%', maxWidth: '300px', height: '200px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #ddd' }} 
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className='mt-2'>
                                                    <label className='branch-field-label' for='#tn'>Description </label>
                                                    <textarea type='text' id='tn' placeholder='Write description ...' defaultValue={item.description} className='branch-input' onChange={(e) => handleInputChange(e, index, 'description')} />
                                                </div>
                                                {!item._id ? (
                                                    <div className='mt-3 text-end'>
                                                        <button className='branch-btn branch-btn-primary branch-btn-sm' onClick={() => handleOneAdd(item)}>Add</button>
                                                    </div>
                                                ) : (
                                                    <div className='mt-3 text-end'>
                                                        <button className='branch-btn branch-btn-primary branch-btn-sm' onClick={() => handleOneUpdate(item)}>Update</button>
                                                    </div>
                                                )}

                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <h3 className=''>Tretment Detail Section</h3>
                                )}

                                {/* To add next section */}
                                <div className='mt-3'>
                                    <button className='branch-btn branch-btn-outline' onClick={AddSection}>Add Section</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer Button */}
                    <div className='branch-form-footer'>
                        <Link to='/treatment-dashboard' className='branch-btn branch-btn-outline'>Cancel</Link>
                        <button className='branch-btn branch-btn-primary' onClick={create}>Update</button>
                    </div>
                </div>
            </div>
        </div >
    )
}
